import React from 'react';
import adImage from '../assets/399.99 first time ad.png';

export const ShopifyAd = ({ shopifyLink }) => (
  <section className="py-16 bg-slate-950">
    <div className="max-w-6xl mx-auto px-4">
      <div className="overflow-hidden rounded-[2rem] border border-slate-700 bg-slate-900 shadow-2xl">
        <img
          src={adImage}
          alt="Campbell's Flying Machines First Time Buyer Package"
          className="w-full max-h-[720px] object-cover"
        />
        <div className="bg-slate-950 px-6 py-8 text-center">
          <p className="text-slate-400 mb-4">Click below to learn more about the first time buyer package on Shopify.</p>
          <a
            href={shopifyLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center rounded-3xl bg-emerald-500 px-8 py-4 text-base font-semibold text-slate-950 transition hover:bg-emerald-400"
          >
            View on Shopify
          </a>
        </div>
      </div>
    </div>
  </section>
);
